export default "__VITE_ASSET__dc63b361__"